import { Component } from '@verndale/core';
import Stickyfill from 'stickyfilljs';

import { constEvent } from '../utils/constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $modules: document._$$('[data-anchor-bar]'),
      $container: this.el._$('.pdp-anchor-bar__container'),
      $wrapper: this.el._$('.pdp-anchor-bar__links-wrapper'),
      $current: this.el._$('.pdp-anchor-bar__links--current'),
      $linksContainer: this.el._$('.pdp-anchor-bar__links')
    };
    this.currentOpenClass = 'pdp-anchor-bar__links--current-open';
    this.linkClasses = 'link link--primary pdp-anchor-bar__link';
    this.firstModuleClasses = 'link link--primary';
    this.isStickyClass = 'pdp-anchor-bar--is-sticky';
    this.currentLinkClass = 'pdp-anchor-bar__link--current';
    this.isOpen = false;

    this.init();
  } //setupDefaults

  addListeners() {
    const { $current, $links } = this.dom;

    $links?._on('click', this.anchorHandleClick.bind(this));
    $current?._on('click', this.toggleList.bind(this));
    window._on('scroll', this.activeNav.bind(this));
    document._on('click', this.handleClickOutside.bind(this));
    document._on(
      constEvent.PDP_REMOVED_REFERENCES,
      this.removedReferences.bind(this)
    );
  } //addListeners

  init() {
    this.setAnchorLinks();
    this.sticky();
    window.onload=function(){
      const innerLinksItems = document.querySelectorAll('.pdp-anchor-bar__links > a');
      if (innerLinksItems.length > 4){
        innerLinksItems.forEach(item => {
          item.innerHTML = `<span>${item.innerText.split(' ').join(' </br>')}</span>`;
        });
      }
    }

    $(document).on('click', '.product-info-link .link', e => {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $('#detailed-product-information').offset().top - 80
      }, 600);
    })

    $('.biosafety-callout__title').on('click', function() {
      $(this).toggleClass('is-open');
      $(this).siblings('.biosafety-callout__text').slideToggle();
    })

    $('.pdp-anchor-bar__links-wrapper .link').on('click', () => {
      $('.pdp-anchor-bar__links-wrapper').addClass('active-nav');
    })

  } //init

  setAnchorLinks() {
    const { $modules, $container, $current, $linksContainer } = this.dom;

    if ($modules && $modules.length >= 1) {
      $container.style.display = 'block';

      try {
        for (const [index, $module] of $modules.entries()) {
          const getAnchorName = $module.getAttribute('data-anchor-bar');
          const getAnchorId = $module.getAttribute('id');

          const $singleLink = document.createElement('a');
          $singleLink.href = `#${getAnchorId}`;
          $singleLink.setAttribute('data-anchor-id', getAnchorId);
          $singleLink.className = this.linkClasses;
          $singleLink.textContent = getAnchorName;
          $linksContainer.appendChild($singleLink);

          if (index === 0) {
            const $firstModule = document.createElement('span');
            $firstModule.className = this.firstModuleClasses;
            $firstModule.textContent = '';
            $current.appendChild($firstModule);
          }
        }
      } catch (error) {
        return;
      }
    } else {
      $container.style.display = 'none';
    }

    this.dom = {
      ...this.dom,
      $links: this.el._$$('.pdp-anchor-bar__link'),
      $currentLink: this.el._$('.pdp-anchor-bar__links--current .link')
    };

  } //setAnchorLinks

  removedReferences(e) {
    const anchorId = e?.detail || null;

    this.dom = {
      ...this.dom,
      $modules: document._$$('[data-anchor-bar]')
    };

    const { $modules, $links, $container } = this.dom;

    if ($modules && $modules.length >= 1) {
      $container.style.display = 'block';

      try {
        for (const [$index, $link] of $links.entries()) {
          if ($link?.dataset?.anchorId === anchorId) $link.remove();
        }
      } catch (error) {
        return;
      }
    } else {
      $container.style.display = 'none';
    }
  } //removedReferences

  sticky() {
    const { $el } = this.dom;

    try {
      Stickyfill.addOne($el);

      const observer = new IntersectionObserver(
        ([e]) =>
          e.target.classList.toggle(
            this.isStickyClass,
            e.intersectionRatio < 1
          ),
        { threshold: [1] }
      );
      observer.observe($el);
    } catch (error) {
      return;
    }
  } //sticky

  anchorHandleClick(e) {
    e.preventDefault();
    const { $wrapper, $currentLink } = this.dom;

    try {
      const href = e.currentTarget.getAttribute('href');
      const anchorId = e.currentTarget.getAttribute('data-anchor-id') || '';
      const currentText = e.currentTarget.textContent;
      const $module = document.getElementById(anchorId);

      if (window.history.pushState) {
        window.history.pushState({}, null, href);
      }

      if ($module) {
        const offset = $wrapper.offsetHeight;
        const modulePosition = $module.offsetTop;
        const offsetPosition = modulePosition - offset;

        $currentLink.textContent = currentText;

        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }

      this.collapseDropdown();
    } catch (error) {
      return;
    }

  } //anchorHandleClick

  toggleList(e) {
    e.preventDefault();
    const { $current, $linksContainer } = this.dom;

    try {
      $current.classList.toggle(this.currentOpenClass);

      if ($linksContainer.style.maxHeight) {
        $linksContainer.style.maxHeight = null;
        this.isOpen = false;
      } else {
        $linksContainer.style.maxHeight = `${$linksContainer.scrollHeight}px`;
        this.isOpen = true;
      }
    } catch (error) {
      return;
    }
  } //toggleList

  activeNav() {
    const { $links, $currentLink, $wrapper } = this.dom;

    try {
      const fromTop = window.pageYOffset + $wrapper.offsetHeight;

      for (const $link of $links) {
        const section = document.querySelector($link.hash);

        if (
          section?.offsetTop <= fromTop &&
          section?.offsetTop + section.offsetHeight > fromTop
        ) {
          $currentLink.textContent = $link.textContent;
          $link.classList.add(this.currentLinkClass);
        } else {
          $link.classList.remove(this.currentLinkClass);
        }
      }
    } catch (error) {
      return;
    }
  } //activeNav

  collapseDropdown() {
    const { $current, $linksContainer } = this.dom;

    try {
      $current.classList.remove(this.currentOpenClass);
      $linksContainer.style.maxHeight = null;
      this.isOpen = false;
    } catch (error) {
      return;
    }
  } //collapseDropdown

  handleClickOutside(e) {
    if (this.isOpen) {
      const { $wrapper } = this.dom;
      const isClickInside = $wrapper.contains(e.target);

      if (!isClickInside) {
        this.collapseDropdown();
      }
    } else {
      return;
    }
  } //handleClickOutside

}

export default Module;
